// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  width: auto;
}

.modal-backdrop {
  background-color: #fff;
}

.modal-backdrop.in {
  filter: alpha(opacity=90);
  opacity: 0.9;
}

.modal-header {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 15px;
}

/* Modal title */
.modal .modal-title {
  font-weight: bold;
  font-size: 20px;
  margin: 0px 20px 0 0px;
  word-wrap: break-word;
}

.modal .closer {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  cursor: pointer;
  color: black;
  font-weight: normal;
  font-size: 18px;
  height: 20px;
  line-height: 17px;
  position: absolute;
  right: 15px;
  text-align: center;
  top: 15px;
  width: 20px;
}

.modal .modal-dialog {
  max-width: 1000px;
}

.modal .modal-dialog .modal-content {
  box-shadow: none;
  border: none;
  background-color: #e5e5e5;
  border-radius: 0;
  width: 100%;
}

/* Modal body */
.modal .modal-dialog .modal-content .modal-body {
  padding: 0px 15px 15px;
  overflow: hidden;
  width: 100%;
}

/*.*/

.modal .modal-body form {
  margin-top: 0;
}

.modal .modal-body .navbar-form {
  width: 100%;
}

.modal .modal-body .navbar-form .form-group {
  margin-bottom: 15px;
}

.modal .modal-body .navbar-form .form-group,
.modal .modal-body .navbar-form .form-group label,
.modal .modal-body .navbar-form .form-group .input-group {
  width: 100%;
}

/* Remove css garbage on modal inputs from other parts of app */
.modal .modal-body input[type='text'],
.modal .modal-body textarea,
.modal .modal-body md-datepicker-input,
.modal .modal-body input[type='number'] {
  border-radius: 0;
  border: 1px solid black;
  width: 100%;
}
/* color the default text in the modal input boxes */
.modal .modal-body input[type='text']::-webkit-input-placeholder,
.modal .modal-body textarea::-webkit-input-placeholder,
.modal .modal-body .md-datepicker-input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: black;
}
.modal .modal-body input[type='text']:-moz-placeholder,
.modal .modal-body textarea:-moz-placeholder,
.modal .modal-body .md-datepicker-input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: black;
  opacity: 1;
}
.modal .modal-body input[type='text']::-moz-placeholder,
.modal .modal-body textarea::-moz-placeholder,
.modal .modal-body .md-datepicker-input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: black;
  opacity: 1;
}
.modal .modal-body input[type='text']:-ms-input-placeholder,
.modal .modal-body textarea:-ms-input-placeholder,
.modal .modal-body .md-datepicker-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: black;
}

/**** Certificate modal ****/
#certificateModal .modal-dialog .modal-content {
  height: 100%;
}

#certificateModal .modal-header p {
  right: 50px;
  top: 15px;
  position: absolute;
  font-size: 15px;
  cursor: pointer;
}

#certificateModal .modal-body {
  height: 94%;
  width: 100%;
}

#launcherModal .modal-dialog .modal-content {
  height: 100%;
}

/**** Welcome video modal ****/
#welcomeVideoModal {
  margin: 0 auto;
  width: 800px;
}

#welcomeVideoModal .row:first-child {
  margin-bottom: 15px;
}

#welcomeVideoModal .row .checkbox {
  float: left;
  margin-right: 15px;
}

.people-group-audience-modal-spinner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 300px;
  width: 100%;
}

.people-group-audience-modal-info-header {
  height: 40px;
  padding: 5px 12px 5px 12px;
  font-size: 15px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#people-group-audience-modal-table .MuiTable-stickyHeader thead {
  background-color: #f7fcff !important;

  tr th {
    width: auto;
  }
}

.people-group-audience-modal-container,
.copy-people-group-modal-container,
.copy-rules-modal-container,
.people-group-history-modal-container,
.rule-history-modal-container {
  width: 1040px;
  height: 450px;
  max-height: 450px;
}

.batch-edit-modal-container {
  width: 700px !important;
  height: auto;
  max-height: min(82vh, 520px);
  overflow: hidden !important;
  box-sizing: border-box;
}

.step3-batch-edit-modal-container {
  width: 500px !important;
  /* height: 500px;
  max-height: 500px; */
  height: 455px;
  max-height: 455px;
}

.modal-table-react {
  thead th {
    border-top: 0.5px solid darkgray;
    border-bottom: 0.5px solid darkgray;
  }
}

/* Add Assignments Modal*/
.add-assignments-modal-container {
  width: 80vw;
  min-width: 900px;
  max-width: 1400px;
  height: 80vh;
  min-height: 480px;
  max-height: 800px;
  font-family: Calibri, sans-serif !important;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.add-assignments-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5px 12px 0.5px 0px;
}

#add-assignments-modal-table .first-column-header.MuiDataGrid-columnHeader {
  justify-content: center !important;
  text-align: center !important;
  padding-left: 0 !important;
  padding-right: 8px !important;
}

#add-assignments-modal-table .second-column-header.MuiDataGrid-cell {
  display: flex;
  align-items: center;
  text-align: left;
}
#add-assignments-modal-table {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  overflow-x: hidden !important;
  display: flex;
  font-size: 14px !important;
  font-family: Calibri, sans-serif !important;

  .MuiDataGrid-scrollbarFiller--header {
    background-color: #f7fcff;
    margin-top: -2px;
  }

  .MuiDataGrid-filler {
    height: 30px !important;
  }

  .MuiDataGrid-container--top {
    .MuiDataGrid-filler {
      margin-top: -2px;
      background-color: #f7fcff;
      height: var(--DataGrid-topContainerHeight) !important;
    }
  }
  .MuiDataGrid-cell {
    align-self: center !important;
    font-size: 14px !important;
  }
  .MuiDataGrid-columnHeader {
    background-color: #f7fcff !important;
    margin-top: -2px !important;
    border-top: none !important;
    font-weight: 800 !important;

    .column-header-title {
      margin-left: 12px !important;
      font-size: 15px !important;
      font-weight: 800 !important;
    }
  }

  .MuiDataGrid-columnHeaderTitleContainerContent {
    white-space: normal !important;
    overflow: visible !important;
  }

  .MuiDataGrid-virtualScrollerContent {
    .MuiDataGrid-row {
      width: calc(100% - var(--DataGrid-scrollbarSize)) !important;
    }
  }

  .MuiDataGrid-main {
    height: inherit;

    + .MuiBox-root {
      padding: 4px !important;
      height: var(--DataGrid-topContainerHeight) !important;
    }
  }
  .MuiDataGrid-root {
    flex: 1 1 auto !important;
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
  }

  .MuiDataGrid-virtualScroller {
    flex: 1 1 auto !important;
    height: 100% !important;
    min-height: 0 !important;
    max-height: 100% !important;
  }
  .MuiDataGrid-row {
    width: calc(100% - var(--DataGrid-scrollbarSize) - 5px);
    font-size: 14px !important;
  }
}
#add-assignments-modal-table .MuiDataGrid-footerContainer {
  min-height: 44px !important;
  max-height: 44px !important;
  height: 44px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border-radius: 0px 0px 10px 10px;
  background-color: white !important;
  z-index: 10;
}

.add-assignments-modal-spinner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 300px;
  width: 100%;
}

#add-assignments-modal-table > div {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  min-width: 0 !important;
}

.description-cell-inline {
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: 100%;
  min-width: 0;
}

.description-truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: calc(100% - 80px);
  display: inline-block;
}
#add-assignments-modal-table .MuiDataGrid-columnHeader {
  height: 48px !important;
}
#add-assignments-modal-table .MuiDataGrid-columnHeaderTitle {
  font-weight: 800 !important;
  font-family: Calibri, Arial, sans-serif !important;
}
#add-assignments-modal-table .MuiDataGrid-cell {
  font-size: 14px !important;
}
#add-assignments-modal-table .MuiDataGrid-row--lastVisible {
  border-bottom: 1px solid #d9d9d9 !important;
}
.add-assignments-modal-form-bar .MuiFormControl-root {
  all: unset;
}
.cell-image-wrapper {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
}
.cell-image-link {
  display: inline-block;
  line-height: 0;
}
.cell-image {
  width: 80px;
  height: 35px;
  max-width: 90px;
  max-height: 45px;
  object-fit: cover;
  padding-right: 8px;
  cursor: pointer;
}

.truncate-one-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  padding-right: 12px;
  font-size: 14px;
  max-width: 100%;
  cursor: pointer;
}
.code-cell,
.content-type-cell {
  display: block;
  box-sizing: border-box;
  max-inline-size: calc(100% - 15px);
}

.code-cell.truncate,
.content-type-cell.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
}

.code-cell.notruncate,
.content-type-cell.notruncate {
  white-space: normal;
}

.content-type-cell.notruncate {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.description-cell-inline {
  display: flex;
  align-items: center;
}
.description-truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
  font-size: 14px;
}

.btn-link {
  color: #1eabe3;
  background: transparent !important;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-left: 6px;
  text-decoration: underline;
  padding: 0;
}
#add-assignments-modal-table .description-cell-inline button {
  background: transparent !important;
  background-color: transparent !important;
}

.sixth-column-header {
  padding-right: 20px !important;
}
#add-assignments-modal-table .truncate-one-line {
  cursor: default;
}
.NoRowsOverlay {
  display: grid;
  padding: 12px 16px;
  font-size: 16;
  color: black;
  text-align: left;
  width: 100%;
}
.add-assignments-modal-library-filter-row {
  display: flex;
  align-items: center;
  padding: 4px 12px 4px;
  position: relative;
  z-index: 2;
  background: #fff;
  height: 72px;
}

/* The only places we want a pointer (finger) */
#add-assignments-modal-table .cell-image-link,
#add-assignments-modal-table .second-column-header .truncate-one-line a {
  cursor: pointer;
}

#add-assignments-modal-table .MuiDataGrid-cell,
#add-assignments-modal-table .MuiDataGrid-row:hover {
  cursor: default;
}

.add-assignments-modal-container .assignments-search-input::placeholder {
  color: #cfcfcf !important;
  opacity: 1;
}

/* End Add Assignments Modal*/

/* Step 3 Edit Batch Modal */
.step3editbatch-tooltip-icon {
  width: 18px;
  height: 18px;
}

.step3BatchEditFooter {
  display: flex;
  height: 62px;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid gray;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 100%;
  background-color: white;
  padding: 12px 12px;
}
.footer-save-box {
  display: flex;
  justify-content: center;
}

.step3editbatch-tooltip-button {
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 5px;
}

.step3editbatch-error {
  margin-top: 0px !important;
  margin-bottom: 2px !important;
  margin-left: 4px;
  font-size: 12px !important;
  color: red !important;
  font-family: Calibri, sans-serif;
}

.step3-batch-edit-modal-container .react-datepicker-wrapper {
  width: 175px;
}

.step3-batch-edit-dropdown {
  width: 150px;
}

.step3-batch-edit-dropdown .MuiSelect-select {
  border: 1px solid rgb(204, 204, 204);
  border-radius: 3px !important;
  background-color: white;
  color: black;
  font-family: Calibri, sans-serif;
  font-size: 14px;
  margin-bottom: 0 !important;
  padding: 1px 5px;
  text-align: left;
}

.step3-batch-edit-dropdown .MuiSelect-select.Mui-disabled {
  background-color: #f5f5f5;
}

.step3-batch-edit-dropdown fieldset {
  border: none;
}

.step3-batch-edit-dropdown legend {
  display: none;
}

.step3-batch-edit-dropdown .MuiOutlinedInput-root {
  border-color: #ccc !important;
}

.step3-batch-edit-dropdown svg {
  fill: black;
}

.step3-batch-edit-dropdown .MuiPaper-root {
  border: 1px solid rgb(204, 204, 204);
  border-radius: 0 0 3px 3px !important;
  margin-right: 1em;
  margin-top: -2px;
  min-width: 146px;
  max-width: 146px;
  width: 146px;
  height: auto;
  margin-left: 0;
  left: auto;
}

.step3-batch-edit-dropdown .MuiMenuItem-root {
  padding: 0.2em 0.2em;
  margin-left: 2px;
}

.step3-batch-edit-dropdown .MuiList-root {
  color: black;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.step3-batch-edit-dropdown .MuiMenuItem-root.Mui-focusVisible {
  background-color: #fafbff;
}

/* End Step 3 Edit Batch Modal */
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/modals.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA,IAAI;;AAEJ;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;AACb;;AAEA,+DAA+D;AAC/D;;;;EAIE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA,oDAAoD;AACpD;;;EAGE,wBAAwB;EACxB,YAAY;AACd;AACA;;;EAGE,4BAA4B;EAC5B,YAAY;EACZ,UAAU;AACZ;AACA;;;EAGE,wBAAwB;EACxB,YAAY;EACZ,UAAU;AACZ;AACA;;;EAGE,4BAA4B;EAC5B,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;;EAEpC;IACE,WAAW;EACb;AACF;;AAEA;;;;;EAKE,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB;sBACoB;EACpB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,gCAAgC;IAChC,mCAAmC;EACrC;AACF;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;EAC3C,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,0BAA0B;EAC1B,2CAA2C;;EAE3C;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;MACE,gBAAgB;MAChB,yBAAyB;MACzB,qDAAqD;IACvD;EACF;EACA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;EACA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;;IAE3B;MACE,4BAA4B;MAC5B,0BAA0B;MAC1B,2BAA2B;IAC7B;EACF;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE;MACE,4DAA4D;IAC9D;EACF;;EAEA;IACE,eAAe;;IAEf;MACE,uBAAuB;MACvB,qDAAqD;IACvD;EACF;EACA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;EAC7B;EACA;IACE,uDAAuD;IACvD,0BAA0B;EAC5B;AACF;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,6BAA6B;;AAE7B,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC","sourcesContent":[".modal {\n  width: auto;\n}\n\n.modal-backdrop {\n  background-color: #fff;\n}\n\n.modal-backdrop.in {\n  filter: alpha(opacity=90);\n  opacity: 0.9;\n}\n\n.modal-header {\n  border-bottom: 0;\n  margin-bottom: 0;\n  padding-bottom: 15px;\n}\n\n/* Modal title */\n.modal .modal-title {\n  font-weight: bold;\n  font-size: 20px;\n  margin: 0px 20px 0 0px;\n  word-wrap: break-word;\n}\n\n.modal .closer {\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  color: black;\n  font-weight: normal;\n  font-size: 18px;\n  height: 20px;\n  line-height: 17px;\n  position: absolute;\n  right: 15px;\n  text-align: center;\n  top: 15px;\n  width: 20px;\n}\n\n.modal .modal-dialog {\n  max-width: 1000px;\n}\n\n.modal .modal-dialog .modal-content {\n  box-shadow: none;\n  border: none;\n  background-color: #e5e5e5;\n  border-radius: 0;\n  width: 100%;\n}\n\n/* Modal body */\n.modal .modal-dialog .modal-content .modal-body {\n  padding: 0px 15px 15px;\n  overflow: hidden;\n  width: 100%;\n}\n\n/*.*/\n\n.modal .modal-body form {\n  margin-top: 0;\n}\n\n.modal .modal-body .navbar-form {\n  width: 100%;\n}\n\n.modal .modal-body .navbar-form .form-group {\n  margin-bottom: 15px;\n}\n\n.modal .modal-body .navbar-form .form-group,\n.modal .modal-body .navbar-form .form-group label,\n.modal .modal-body .navbar-form .form-group .input-group {\n  width: 100%;\n}\n\n/* Remove css garbage on modal inputs from other parts of app */\n.modal .modal-body input[type='text'],\n.modal .modal-body textarea,\n.modal .modal-body md-datepicker-input,\n.modal .modal-body input[type='number'] {\n  border-radius: 0;\n  border: 1px solid black;\n  width: 100%;\n}\n/* color the default text in the modal input boxes */\n.modal .modal-body input[type='text']::-webkit-input-placeholder,\n.modal .modal-body textarea::-webkit-input-placeholder,\n.modal .modal-body .md-datepicker-input::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: black;\n}\n.modal .modal-body input[type='text']:-moz-placeholder,\n.modal .modal-body textarea:-moz-placeholder,\n.modal .modal-body .md-datepicker-input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: black;\n  opacity: 1;\n}\n.modal .modal-body input[type='text']::-moz-placeholder,\n.modal .modal-body textarea::-moz-placeholder,\n.modal .modal-body .md-datepicker-input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: black;\n  opacity: 1;\n}\n.modal .modal-body input[type='text']:-ms-input-placeholder,\n.modal .modal-body textarea:-ms-input-placeholder,\n.modal .modal-body .md-datepicker-input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: black;\n}\n\n/**** Certificate modal ****/\n#certificateModal .modal-dialog .modal-content {\n  height: 100%;\n}\n\n#certificateModal .modal-header p {\n  right: 50px;\n  top: 15px;\n  position: absolute;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n#certificateModal .modal-body {\n  height: 94%;\n  width: 100%;\n}\n\n#launcherModal .modal-dialog .modal-content {\n  height: 100%;\n}\n\n/**** Welcome video modal ****/\n#welcomeVideoModal {\n  margin: 0 auto;\n  width: 800px;\n}\n\n#welcomeVideoModal .row:first-child {\n  margin-bottom: 15px;\n}\n\n#welcomeVideoModal .row .checkbox {\n  float: left;\n  margin-right: 15px;\n}\n\n.people-group-audience-modal-spinner {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n}\n\n.people-group-audience-modal-info-header {\n  height: 40px;\n  padding: 5px 12px 5px 12px;\n  font-size: 15px;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n#people-group-audience-modal-table .MuiTable-stickyHeader thead {\n  background-color: #f7fcff !important;\n\n  tr th {\n    width: auto;\n  }\n}\n\n.people-group-audience-modal-container,\n.copy-people-group-modal-container,\n.copy-rules-modal-container,\n.people-group-history-modal-container,\n.rule-history-modal-container {\n  width: 1040px;\n  height: 450px;\n  max-height: 450px;\n}\n\n.batch-edit-modal-container {\n  width: 700px !important;\n  height: auto;\n  max-height: min(82vh, 520px);\n  overflow: hidden !important;\n  box-sizing: border-box;\n}\n\n.step3-batch-edit-modal-container {\n  width: 500px !important;\n  /* height: 500px;\n  max-height: 500px; */\n  height: 455px;\n  max-height: 455px;\n}\n\n.modal-table-react {\n  thead th {\n    border-top: 0.5px solid darkgray;\n    border-bottom: 0.5px solid darkgray;\n  }\n}\n\n/* Add Assignments Modal*/\n.add-assignments-modal-container {\n  width: 80vw;\n  min-width: 900px;\n  max-width: 1400px;\n  height: 80vh;\n  min-height: 480px;\n  max-height: 800px;\n  font-family: Calibri, sans-serif !important;\n  box-sizing: border-box;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.add-assignments-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5px 12px 0.5px 0px;\n}\n\n#add-assignments-modal-table .first-column-header.MuiDataGrid-columnHeader {\n  justify-content: center !important;\n  text-align: center !important;\n  padding-left: 0 !important;\n  padding-right: 8px !important;\n}\n\n#add-assignments-modal-table .second-column-header.MuiDataGrid-cell {\n  display: flex;\n  align-items: center;\n  text-align: left;\n}\n#add-assignments-modal-table {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  overflow-x: hidden !important;\n  display: flex;\n  font-size: 14px !important;\n  font-family: Calibri, sans-serif !important;\n\n  .MuiDataGrid-scrollbarFiller--header {\n    background-color: #f7fcff;\n    margin-top: -2px;\n  }\n\n  .MuiDataGrid-filler {\n    height: 30px !important;\n  }\n\n  .MuiDataGrid-container--top {\n    .MuiDataGrid-filler {\n      margin-top: -2px;\n      background-color: #f7fcff;\n      height: var(--DataGrid-topContainerHeight) !important;\n    }\n  }\n  .MuiDataGrid-cell {\n    align-self: center !important;\n    font-size: 14px !important;\n  }\n  .MuiDataGrid-columnHeader {\n    background-color: #f7fcff !important;\n    margin-top: -2px !important;\n    border-top: none !important;\n    font-weight: 800 !important;\n\n    .column-header-title {\n      margin-left: 12px !important;\n      font-size: 15px !important;\n      font-weight: 800 !important;\n    }\n  }\n\n  .MuiDataGrid-columnHeaderTitleContainerContent {\n    white-space: normal !important;\n    overflow: visible !important;\n  }\n\n  .MuiDataGrid-virtualScrollerContent {\n    .MuiDataGrid-row {\n      width: calc(100% - var(--DataGrid-scrollbarSize)) !important;\n    }\n  }\n\n  .MuiDataGrid-main {\n    height: inherit;\n\n    + .MuiBox-root {\n      padding: 4px !important;\n      height: var(--DataGrid-topContainerHeight) !important;\n    }\n  }\n  .MuiDataGrid-root {\n    flex: 1 1 auto !important;\n    display: flex !important;\n    flex-direction: column !important;\n    width: 100% !important;\n    height: 100% !important;\n    min-width: 0 !important;\n    min-height: 0 !important;\n  }\n\n  .MuiDataGrid-virtualScroller {\n    flex: 1 1 auto !important;\n    height: 100% !important;\n    min-height: 0 !important;\n    max-height: 100% !important;\n  }\n  .MuiDataGrid-row {\n    width: calc(100% - var(--DataGrid-scrollbarSize) - 5px);\n    font-size: 14px !important;\n  }\n}\n#add-assignments-modal-table .MuiDataGrid-footerContainer {\n  min-height: 44px !important;\n  max-height: 44px !important;\n  height: 44px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border-radius: 0px 0px 10px 10px;\n  background-color: white !important;\n  z-index: 10;\n}\n\n.add-assignments-modal-spinner {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n}\n\n#add-assignments-modal-table > div {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n}\n\n.description-cell-inline {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  width: 100%;\n  min-width: 0;\n}\n\n.description-truncate-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  max-width: calc(100% - 80px);\n  display: inline-block;\n}\n#add-assignments-modal-table .MuiDataGrid-columnHeader {\n  height: 48px !important;\n}\n#add-assignments-modal-table .MuiDataGrid-columnHeaderTitle {\n  font-weight: 800 !important;\n  font-family: Calibri, Arial, sans-serif !important;\n}\n#add-assignments-modal-table .MuiDataGrid-cell {\n  font-size: 14px !important;\n}\n#add-assignments-modal-table .MuiDataGrid-row--lastVisible {\n  border-bottom: 1px solid #d9d9d9 !important;\n}\n.add-assignments-modal-form-bar .MuiFormControl-root {\n  all: unset;\n}\n.cell-image-wrapper {\n  display: flex;\n  justify-content: center !important;\n  align-items: center !important;\n  height: 100%;\n}\n.cell-image-link {\n  display: inline-block;\n  line-height: 0;\n}\n.cell-image {\n  width: 80px;\n  height: 35px;\n  max-width: 90px;\n  max-height: 45px;\n  object-fit: cover;\n  padding-right: 8px;\n  cursor: pointer;\n}\n\n.truncate-one-line {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  padding-right: 12px;\n  font-size: 14px;\n  max-width: 100%;\n  cursor: pointer;\n}\n.code-cell,\n.content-type-cell {\n  display: block;\n  box-sizing: border-box;\n  max-inline-size: calc(100% - 15px);\n}\n\n.code-cell.truncate,\n.content-type-cell.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: default;\n}\n\n.code-cell.notruncate,\n.content-type-cell.notruncate {\n  white-space: normal;\n}\n\n.content-type-cell.notruncate {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.description-cell-inline {\n  display: flex;\n  align-items: center;\n}\n.description-truncate-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  max-width: 100%;\n  font-size: 14px;\n}\n\n.btn-link {\n  color: #1eabe3;\n  background: transparent !important;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  margin-left: 6px;\n  text-decoration: underline;\n  padding: 0;\n}\n#add-assignments-modal-table .description-cell-inline button {\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.sixth-column-header {\n  padding-right: 20px !important;\n}\n#add-assignments-modal-table .truncate-one-line {\n  cursor: default;\n}\n.NoRowsOverlay {\n  display: grid;\n  padding: 12px 16px;\n  font-size: 16;\n  color: black;\n  text-align: left;\n  width: 100%;\n}\n.add-assignments-modal-library-filter-row {\n  display: flex;\n  align-items: center;\n  padding: 4px 12px 4px;\n  position: relative;\n  z-index: 2;\n  background: #fff;\n  height: 72px;\n}\n\n/* The only places we want a pointer (finger) */\n#add-assignments-modal-table .cell-image-link,\n#add-assignments-modal-table .second-column-header .truncate-one-line a {\n  cursor: pointer;\n}\n\n#add-assignments-modal-table .MuiDataGrid-cell,\n#add-assignments-modal-table .MuiDataGrid-row:hover {\n  cursor: default;\n}\n\n.add-assignments-modal-container .assignments-search-input::placeholder {\n  color: #cfcfcf !important;\n  opacity: 1;\n}\n\n/* End Add Assignments Modal*/\n\n/* Step 3 Edit Batch Modal */\n.step3editbatch-tooltip-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.step3BatchEditFooter {\n  display: flex;\n  height: 62px;\n  justify-content: flex-end;\n  align-items: center;\n  border-top: 1px solid gray;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  width: 100%;\n  background-color: white;\n  padding: 12px 12px;\n}\n.footer-save-box {\n  display: flex;\n  justify-content: center;\n}\n\n.step3editbatch-tooltip-button {\n  border: none;\n  background: transparent;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-top: 5px;\n}\n\n.step3editbatch-error {\n  margin-top: 0px !important;\n  margin-bottom: 2px !important;\n  margin-left: 4px;\n  font-size: 12px !important;\n  color: red !important;\n  font-family: Calibri, sans-serif;\n}\n\n.step3-batch-edit-modal-container .react-datepicker-wrapper {\n  width: 175px;\n}\n\n.step3-batch-edit-dropdown {\n  width: 150px;\n}\n\n.step3-batch-edit-dropdown .MuiSelect-select {\n  border: 1px solid rgb(204, 204, 204);\n  border-radius: 3px !important;\n  background-color: white;\n  color: black;\n  font-family: Calibri, sans-serif;\n  font-size: 14px;\n  margin-bottom: 0 !important;\n  padding: 1px 5px;\n  text-align: left;\n}\n\n.step3-batch-edit-dropdown .MuiSelect-select.Mui-disabled {\n  background-color: #f5f5f5;\n}\n\n.step3-batch-edit-dropdown fieldset {\n  border: none;\n}\n\n.step3-batch-edit-dropdown legend {\n  display: none;\n}\n\n.step3-batch-edit-dropdown .MuiOutlinedInput-root {\n  border-color: #ccc !important;\n}\n\n.step3-batch-edit-dropdown svg {\n  fill: black;\n}\n\n.step3-batch-edit-dropdown .MuiPaper-root {\n  border: 1px solid rgb(204, 204, 204);\n  border-radius: 0 0 3px 3px !important;\n  margin-right: 1em;\n  margin-top: -2px;\n  min-width: 146px;\n  max-width: 146px;\n  width: 146px;\n  height: auto;\n  margin-left: 0;\n  left: auto;\n}\n\n.step3-batch-edit-dropdown .MuiMenuItem-root {\n  padding: 0.2em 0.2em;\n  margin-left: 2px;\n}\n\n.step3-batch-edit-dropdown .MuiList-root {\n  color: black;\n  padding-top: 0;\n  padding-bottom: 0;\n  overflow: hidden;\n}\n\n.step3-batch-edit-dropdown .MuiMenuItem-root.Mui-focusVisible {\n  background-color: #fafbff;\n}\n\n/* End Step 3 Edit Batch Modal */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
